const e = "Διαμερίσματα", s = "Διαμερίσματα", t = "Επαγγελματικό", o = "κάμπινγκ", n = "Ζευγάρι", i = "Οικογενειακό", r = "Με φίλους", l = "Ξενώνες", a = "Ξενοδοχεία", m = "Θέρετρα", c = "Εστιατόρια", u = {
  "{num} reviews": "{num} Κριτικές",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} in {location}",
  "All languages": "Όλες οι γλώσσες",
  "All traveler types": "Όλοι οι τύποι ταξιδιωτών",
  Aparthotels: e,
  Apartments: s,
  "B&Bs": "B & Bs",
  "based on {number} reviews": "με βάση {number} Κριτικές",
  Business: t,
  Campsites: o,
  Couple: n,
  Family: i,
  Friend: r,
  "Highlighted reviews": "Καλύτερες Κριτικές",
  Hostels: l,
  Hotels: a,
  "No reviews found": "Δεν βρέθηκαν κριτικές",
  "Pet-friendly": "Φιλικό προς τα κατοικίδια",
  "Posted on {reviewer}": "Δημοσιεύτηκε στο {reviewer}",
  "Read Reviews": "Διαβάστε Κριτικές",
  Resorts: m,
  Restaurants: c,
  "Review Summary": "Κριτικές",
  "Reviews by Source": "Κριτικές ανά προέλευση"
};
export {
  e as Aparthotels,
  s as Apartments,
  t as Business,
  o as Campsites,
  n as Couple,
  i as Family,
  r as Friend,
  l as Hostels,
  a as Hotels,
  m as Resorts,
  c as Restaurants,
  u as default
};
//# sourceMappingURL=el.9qILPcRF.js.map
